import { memo } from "react";
import PropTypes from "prop-types";
import { Popup } from "@components/Popup";
import ALButtonV2 from "./ALButtonV2";
import CircleCheck from "@svgs/circle-check.svg";
import CloseIcon from "@svgs/close-delete.svg";
import { withALErrorBoundary } from "@helpers/ErrorBoundary/ALErrorBoundary";

import "./ALPopup.scss";

function ALPopup({
  isOpen,
  onClose,
  children,
  title,
  ctaTitle,
  ctaOnClick,
  ctaSuccess,
  isLoading,
  ctaError,
  ctaDisabled,
  smallPrintText,
  showSuccessIcon = true,
  compactTitle = false,
  customClass = "",
  contentClassName = "",
  titleClassName = "",
  showCloseIcon = true,
  noContentPadding = false,
}) {
  const contentClasses =
    contentClassName ||
    (noContentPadding ? "" : "pt-[40px] pb-[20px] px-[20px] desktop:px-[30px] desktop:pb-[30px]");

  return (
    <Popup
      open={isOpen}
      closeOnDocumentClick
      onClose={onClose}
      className={customClass || "al-popup"}
    >
      <div className={`relative max-h-[90vh] overflow-y-auto ${contentClasses}`}>
        {showCloseIcon && (
          <button
            type="button"
            className="absolute top-[20px] right-[20px] z-10 focus:outline-none"
            onClick={onClose}
            aria-label="Close popup"
          >
            <CloseIcon fill="black" width="15" height="15" />
          </button>
        )}
        {title && (
          <h2
            className={
              titleClassName || `typo-h2-bold mb-[10px] ${!compactTitle ? "desktop:mb-[15px]" : ""}`
            }
          >
            {title}
          </h2>
        )}
        {children}
        {ctaTitle && (
          <ALButtonV2
            onClick={ctaOnClick}
            isLoading={isLoading}
            fullWidth
            className="mt-[25px]"
            size="large"
            disabled={ctaDisabled}
          >
            {ctaTitle}
          </ALButtonV2>
        )}
        {ctaSuccess && !ctaError && (
          <div className="flex items-center mt-[10px]">
            {showSuccessIcon && (
              <CircleCheck
                stroke="#26C653"
                className="text-[17px] desktop:text-[18px] flex-shrink-0"
              />
            )}
            <span className={`typo-body ${showSuccessIcon ? "ml-[10px]" : "mb-[5px]"}`}>
              {ctaSuccess}
            </span>
          </div>
        )}
        {ctaError && <div className="mt-[10px] typo-body text-error">{ctaError}</div>}
        {smallPrintText && <div className="typo-micro mt-[10px]">{smallPrintText}</div>}
      </div>
    </Popup>
  );
}

ALPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  title: PropTypes.string,
  ctaTitle: PropTypes.string,
  ctaOnClick: PropTypes.func,
  ctaSuccess: PropTypes.string,
  ctaError: PropTypes.string,
  ctaDisabled: PropTypes.bool,
  smallPrintText: PropTypes.node,
  isLoading: PropTypes.bool,
  showSuccessIcon: PropTypes.bool,
  compactTitle: PropTypes.bool,
  customClass: PropTypes.string,
  contentClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  showCloseIcon: PropTypes.bool,
  noContentPadding: PropTypes.bool,
};

export default withALErrorBoundary({
  name: "ALPopup",
  priority: "P1",
})(memo(ALPopup));
